'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Styles = require('../utils/Styles');

var _sizes = require('HubStyleTokens/sizes');

var _UIFlex = require('./UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FlexContainer = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'UIButtonWrapper__FlexContainer'
})(['margin-left:-', ';margin-top:-', ';max-width:none;width:auto;@media only screen and (max-width:', '){flex-grow:1;}&&& > *{margin-left:', ';margin-top:', ';}'], function (props) {
  return (0, _Styles.toPx)(props.horizontalGap);
}, function (props) {
  return (0, _Styles.toPx)(props.verticalGap);
}, _sizes.GRID_BREAKPOINT_SMALL, function (props) {
  return (0, _Styles.toPx)(props.horizontalGap);
}, function (props) {
  return (0, _Styles.toPx)(props.verticalGap);
});

var UIButtonWrapper = function UIButtonWrapper(props) {
  var alignItems = props.alignItems,
      children = props.children,
      horizontalGap = props.horizontalGap,
      justify = props.justify,
      verticalGap = props.verticalGap,
      rest = _objectWithoutProperties(props, ['alignItems', 'children', 'horizontalGap', 'justify', 'verticalGap']);

  return _react2.default.createElement(
    'div',
    rest,
    _react2.default.createElement(
      FlexContainer,
      {
        align: alignItems,
        horizontalGap: horizontalGap,
        justify: justify,
        verticalGap: verticalGap,
        wrap: 'wrap'
      },
      children
    )
  );
};

UIButtonWrapper.propTypes = {
  alignItems: _UIFlex2.default.propTypes.align,
  children: _propTypes2.default.node,
  justify: _UIFlex2.default.propTypes.justify,
  horizontalGap: _propTypes2.default.number,
  verticalGap: _propTypes2.default.number
};

UIButtonWrapper.defaultProps = {
  alignItems: 'center',
  horizontalGap: parseInt(_sizes.BASE_SPACING_X, 10),
  verticalGap: parseInt(_sizes.BASE_SPACING_Y, 10)
};

UIButtonWrapper.displayName = 'UIButtonWrapper';

exports.default = UIButtonWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/layout/UIButtonWrapper.js
// module id = 205
// module chunks = 177